var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.setClassName,on:{"click":_vm.onClick}},[_c('span',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.iconName))]),_vm._v(_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }